import { isNull } from 'lodash-es'
import { postRequest, retryUntilSuccessOrFailure } from '../utils'

export const computeResults: RequestType = {
  key: ['computeResults'],
  request: async (projectId: string): Promise<void> => {
    const { data: resultsComputeData } = await postRequest<{ task_id: string } | null>({
      url: `/projects/${projectId}/results/compute`,
    })

    if (isNull(resultsComputeData)) throw new Error('Cannot compute results yet')

    await retryUntilSuccessOrFailure({
      url: `/task-status/${resultsComputeData?.task_id}`,
    })
  },
}

export const saveManualLoadsPerSupport: RequestTypeVariable = {
  getKey: (projectId: string) => ['saveManualLoadsPerSupport', projectId],
  request: async (id: string, data: ManualLoadOnSupport[]): Promise<ManualLoadOnSupport[]> => {
    const { data: result } = await postRequest<ManualLoadOnSupport[]>({
      url: `/projects/${id}/manual-loads-per-support`,
      data: data,
    })

    return result as ManualLoadOnSupport[]
  },
}

export const resetPositionChecks: RequestTypeVariable = {
  getKey: (projectId: string) => ['resetPositionChecks', projectId],
  request: async (id: string): Promise<void> => {
    await postRequest<void>({
      url: `/projects/${id}/position-checks/reset`,
    })
  },
}

export const setBackendOtherSettings: RequestTypeVariable = {
  getKey: (projectId: string) => ['setBackendOtherSettings', projectId],
  request: async (id: string, data: BackendOtherSettings): Promise<BackendOtherSettings> => {
    const { data: result } = await postRequest<BackendOtherSettings>({
      url: `/projects/${id}/other-settings`,
      data,
    })
    return result as BackendOtherSettings
  },
}
